import {View} from '@ab/components';
import {connect} from 'react-redux';
import mainTpl from '../templates/notifications';

class Notifications extends View {
    template = mainTpl;

    static displayName = 'Application.views.Notifications';
}

const onStateChange = state => {
    return {
        notifications: state.notifications,
    };
};

export default connect(onStateChange)(Notifications);
